//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        leadUsername: '',
        toRegisteredAt: '',
        fromRegisteredAt: '',
      },
    };
  },

  computed: {
    ...mapState('referralsLeads', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('referralsLeads', ['setFilters']),
  },
};
